import { render, staticRenderFns } from "./pgStatistical.vue?vue&type=template&id=66e23c2a&scoped=true&"
import script from "./pgStatistical.vue?vue&type=script&lang=js&"
export * from "./pgStatistical.vue?vue&type=script&lang=js&"
import style0 from "./pgStatistical.vue?vue&type=style&index=0&id=66e23c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e23c2a",
  null
  
)

export default component.exports